export default {
  // 模式
  "common.mode.auto": "Самостално коришћење произведене енергије",
  "common.mode.economy": "Економички режим",
  "common.mode.exigency": "Режим хитног случаја",

  // 设备
  "common.grid": "Електрична мрежа",
  "common.evChargers": "Упитачке за електричне возила",
  "common.evCharger": "Упитачка за електрично возило",
  "common.pv": "Фотоволтаика (ФВ)",
  "common.inverter": "Инвертор",
  "common.pcs": "Инвертор + батерија",
  "common.terminal": "Терминални уређај",
  "common.airc": "Климатизациони уређај",
  "common.engine": "Мотор",
  "common.battery": "Батерија",
  "common.metter": "Електрични бројник",
  "common.other": "Остало",
  "common.power": "Снага",
  "common.powerTotal": "Укупна снага",
  "common.voltage": "Напон",
  "common.electricity": "Електрична енергија",
  "common.current": "Струја",
  "common.homeUsage": "Укупно оптерећење куће",
  "common.battery.power": "Снага батерије",

  // 数据
  "common.noDataAvailable": "Тренутно нема података~",
  "common.tips": "Савет",
  "common.reset": "Ресетирај",
  "common.currencyUnit": "¥",
  "common.submiting": "Пошаљи се у току... Молимо вас, сачекајте...",
  "common.close": "Затвори",
  "common.from": "Из",
  "common.useIn": "За",
  "common.energyPercent": "Проценат тока енергије",
  "common.dataFlow": "Ток података",
  "common.getDataIng": "Узимам податке... Молимо вас, сачекајте...",
  "common.pageLoading": "Садржај странице се учитава... Молимо вас, сачекајте...",
  "common.reseting": "Ресетирам садржај странице... Молимо вас, сачекајте...",
  "common.save": "Сачувај",
  "common.onlyNumberTips": "Можете унети само бројеве",
  "common.offline": "Офлајн",
  "common.online": "Онлајн",
  "common.fault": "Грешка",
  "common.charge": "Пуњење",
  "common.discharge": "Празњење",
  "common.buy": "Купи",
  "common.sell": "Прођи",
  "common.loadingInfo": "Учитавање у току... Молимо вас, сачекајте...",

  // 
  "common.moreFeatures": "Више функција",
  "common.confirm": "Потврди",
  "common.saveing": "Сачување у току... Молимо вас, сачекајте...",
  "common.searchPlacholder": "Унесите клучну реч за претрагу",
  "common.iSee": "Разумем",
  "common.pageErrorTips1": "Опа, десила се грешка на страници~",
  "common.pageErrorTips2": "Покушајте освежити страницу или контактирајте подршку~",
  "common.refresh": "Освежи",
  "common.backToHome": "Врати се на почетну страницу",
  "common.checkTips": "Провера у току... Молимо вас, сачекајте...",
  "common.back": "Врати се",
  "common.cancel": "Откажи",
  "common.optional": "Опционално",
  "common.required": "Обавезно",
  "common.status": "Статус",
  "common.statusNoDelete": "Није обрисан",
  "common.statusDelete": "Обрисан",
  "common.submit": "Пошаљи",
  "common.disable": "Онемогући",
  "common.enable": "Омогући",
  "common.year": "година",
  "common.month": "месец",
  "common.day": "дан",
  "common.version": "Верзија:",
  "common.backHome": " Врати се на почетну страницу",
  "common.backHomeSorry": "Жао нам је, страница се случајно изгубила",
  "common.requestTips1": "Обрада података је у току, не пошаљите поново",
  "common.requestTips2": "Системска обавештења",
  "common.requestTips3": "Статус пријаве је истекао, пријавите се поново",
  "common.requestTips4": "Поновна пријава",
  "common.requestTips5": "Неважећа сесија или сесија је истекао, пријавите се поново.",
  "common.requestTips6": "Грешка на серверу, молимо покушајте поново касније.",
  "common.requestTips7": "Време трајања захтева за системски интерфејс је истекло",
  "common.requestTips8": "Системски интерфејс",
  "common.requestTips9": "Грешка",
  "common.iknow": "Разумем",
  "common.logoutSuccess": "Успешна одјава",
  
  // 了解更多组件
  "common.knowMore.title": "За више информација, контактирајте Beineng",
  "common.knowMore.email": "Контакт е-пошта",
  "common.knowMore.phone": "Контакт телефон",
  "common.knowMore.wechat": "Контакт WeChat",
  "common.knowMore.website": "Адреса званичне веб-странице",
  "common.knowMore.address": "Контакт адреса",
  "common.knowMore.addressDetail": "Соба 1205 и 1301, Зграда 5, Улица Цинхе 8, Хуанцзинкјенг, Општина Хуанцјан, Град Донг Гуан, Провинција Гуандун",
  
  // 本地连接组件
  "common.localConnection": "Локална веза",
  "common.operateInApp": "Извршите рад у апликацији!",
  
  "common.enbleStaus": "Статус омогућавања",
  "common.battery.status": "Без пуњења и празњења",

  "account.forgetThePassword": "Заборављена лозинка",
  "account.logInDirectly": "Пријави се одмах",
  "account.tips1": "Преусмеравање на страницу у току... Молимо вас, сачекајте...",
  "account.tips2": "Прво прочитајте и прихватите услове коришћења!",
  "account.autoLogin": "Аутоматско пријава",
  "account.userLogin": "Пријављивање корисника",
  "account.registerTips": "Још увек немате налог? Кликните овде за регистрацију",
  "account.userEmail": "Корисничко име / е-пошта",
  "account.userEmailTips": "Унесите корисничко име или е-пошту",
  "account.password": "Лозинка",
  "account.passwordTips": "Унесите лозинку",
  "account.submit": "Пошаљи",
  "account.submitTips": "Пошаљи се у току... Молимо вас, сачекајте...",
  "account.otherLoginTips": "Или изаберите други начин пријава",
  "account.userRegistration": "Регистрација корисника",
  "account.userName": "Корисничко име",
  "account.userNameTips": "Унесите корисничко име",
  "account.emailTips1": "Унесите адресу е-поште",
  "account.emailTips2": "Неважећи формат адресе е-поште",
  "account.phone": "Број телефона",
  "account.phoneTips1": "Унесите број телефона",
  "account.phoneTips2": "Неважећи број телефона",
  "account.phoneTips3": "Унесите број телефона",
  "account.passwordTips1": "Унесите лозинку (6-30 карактера)",
  "account.passwordTips2": "Неважећи формат лозinke: лозинка мора садржати енглеске слова, бројеве, доње црте, црте и тачке, дужина 6-12 карактера",
  "account.passwordTips3": "Две унете лозинке се не поклапају, проверите и унесите поново!",
  "account.passwordTips4": "Унесите лозинку: лозинка мора садржати енглеске слова, бројеве, доње црте, црте и тачке",
  "account.passwordTips5": "Потврда лозинке",
  "account.passwordTips6": "Унесите потврду лозинке",
  "account.passwordTips7": "Две унете лозинке се не поклапају, проверите и унесите поново!",
  "account.passwordTips8": "Унесите потврду лозинке",
  "account.passwordTips9": "Честитамо, регистрација је успешна!",
  "account.passwordTips10": "Ваше корисничко име је:",
  "account.emailIs": "Е-пошта је:",
  "account.goToLoginPage": "Након с секунди ћете бити аутоматски преусмерен на страницу пријава",
  "account.goLogin": "Пријави се",
  "account.goRegister": "Регистрирај се",
  "account.loginSuccess": "Успешна пријава",
  "account.email": "Е-пошта",
  "account.sologn": "Пажљиво креирамо прилагодљив енергетски план за вас",
  "account.pleaseAgree": "Прочитао сам/сама и прихватио сам/сама",
  "userAgreement.privacyPolicy": "политику приватности",

  "account.code": "Верификациони код",
  "account.codeTips": "Унесите верификациони код",
  "account.codeTips2": "Неважећи верификациони код",

    "account.inviteCodeTips": "Молимо унесите код позивнице",
    "account.inviteCodeHint": "Молимо контактирајте инсталатера или особље за одржавање да бисте добили код позивнице",
  "account.modifyPasswordByAccount": "Измена лозинке на основу налога",
  "account.modifyPasswordByEmail": "Измена лозинке на основу е-поште",
  "account.getPasswordByAccount": "Враћање лозинке на основу налога",
  "account.getPasswordByEmail": "Враћање лозинке на основу е-поште",

  "account.sendEmailTips": "Верификациони код је послат на е-пошту, проверите је",
  "account.name": "Име налога",
  "account.newPassword": "Нова лозинка",
  "account.confirmNewPassword": "Потврда нове лозинке",
  "account.nameTips": "Унесите име налога",
  "account.passwordModifySuccess": "Успешна измена лозинке",
  "account.emailCode": "Е-пошта верификационог кода",
  "account.emailCodeTips": "Унесите е-пошту верификационог кода",
  "account.emailCodeTips2": "Неважећи е-пошта верификациони код",
  "account.emailModifySuccess": "Успешна измена лозинке",
  "account.passworTips1": "Ваша лозинка је успешно ресетована!",
  "account.passwordTips11": "Унесите потврду лозинке",
  "account.passwordTips12": "Унесите нову лозинку",
  "account.nickname": "Надимак корисника",
  "account.modifyNickname": "Измена надимка корисника",
  "account.modifyNicknameSuccess": "Успешна измена надимка корисника!",
  "account.nicknameTips": "Унесите надимак корисника",
  "account.nicknameError": "Неуспешна измена надимка корисника!",

  "account.login": "Пријави се",
  "account.quickRegister": "Брза регистрација",
  "account.sendCode": "Пошаљи код",
  "account.sendTips": "Након с секунди можете пошаљите поново",
  "account.sendEmailIng": "Пошаљивање е-поште у току... Молимо вас, сачекајте...",
  "account.emailNotEmpty": "Адреса е-поште не може бити празна",
  "account.registerAccount": "Регистрација налога",
  "account.registerWelcome": "Добродошли у регистрацију SusprSafe",
  "account.usernameLimit": "Корисничко име мора почети словом и може садржати само слова, бројеве и доње црте, дужина 5-15 карактера",

  "copyright.desc2": "Информације о регистрацији веб-странице: ICP регистрација Гуандун брокир 2021169764",

  "editUserInfo.editUserInformation": "Уређивање информација о кориснику",
  "editUserInfo.modifyUsername": "Измена корисничког имена",
  "editUserInfo.changePictures": "Измена профилне слике",
  "editUserInfo.savePicturesSuccess": "Профилна слика корисника је успешно сачувана",
  "editUserInfo.saveError": "Неуспешно сачување",
  "editUserInfo.pictureLimit": "Величина слике мора бити мања од 2 MB",
  "editUserInfo.uploadPicture": "Отпремите профилну слику",
  "editUserInfo.picturePreview": "Преглед",
  
  "editUserInfo.bindPhoneNumber": "Веза броја телефона",
  "editUserInfo.bindEmail": "Веза е-поште",
  "editUserInfo.changePassword": "Измена лозинке",

  "editUserInfo.notificationSettings": "Поставке обавештења",
  "editUserInfo.editAccount": "Уређивање информација о корисничком налогу",
  "editUserInfo.waitBingting": "Веза у току... Молимо вас, сачекајте...",
  "editUserInfo.collapse": "Скупи",
  "editUserInfo.modifyBinding": "Измена везе",
  
  "editUserInfo.emailAddress": "Адреса е-поште",
  "editUserInfo.tips1": "Успешна веза е-поште",
  "editUserInfo.tips2": "Неуспешно сачување",
  "editUserInfo.tips3": "Пошаљивање е-поште верификационог кода у току... Молимо вас, сачекајте...",
  "editUserInfo.tips4": "Верификациони код је послат на е-пошту xxxx, проверите је",
  "editUserInfo.tips5": "Неуспешно пошаљивање верификационог кода!",
  "editUserInfo.tips6": "Број телефона је већ повезан",
  "editUserInfo.tips7": "Е-пошта је већ повезана",
  "editUserInfo.emailTips1": "Унесите адресу е-поште",
  "editUserInfo.emailTips2": "Неважећи формат адресе е-поште",
  "editUserInfo.emailTips3": "Након xxxx секунди можете пошаљите поново",
  "editUserInfo.emailTips4": "Пошаљи код",
  "editUserInfo.emailTips5": "Е-пошта верификациони код не може бити празан",
  "editUserInfo.emailTips6": "Неважећи е-пошта верификациони код",
  "editUserInfo.emailCode": "Е-пошта верификационог кода",
  "editUserInfo.save": "Сачувај",

  "editUserInfo.phoneTips1": "Успешна веза броја телефона",
  "editUserInfo.phoneTips2": "Пошаљивање SMS верификационог кода у току... Молимо вас, сачекајте...",
  "editUserInfo.phoneTips3": "SMS верификациони код је послат на број телефона xxxx, проверите га",
  "editUserInfo.phoneTips4": "Неуспешно пошаљивање SMS верификационог кода!",
  "editUserInfo.phoneTips5": "Унесите број телефона",
  "editUserInfo.phoneTips6": "Неважећи формат броја телефона",
  "editUserInfo.phoneTips7": "Пошаљи SMS верификациони код",
  "editUserInfo.phoneTips8": "SMS верификациони код",
  "editUserInfo.phoneTips9": "SMS верификациони код не може бити празан",
  "editUserInfo.phoneTips10": "Неважећи SMS верификациони код",
  "editUserInfo.phone": "Број телефона",


  "editUserInfo.noticeTips1": "Неуспешно узимање поставки обавештења!",
  "editUserInfo.noticeTips2": "Поставке обавештења су успешно сачуване!",
  "editUserInfo.noticeTips3": "Обавештење о низком нивоу батерије",
  "editUserInfo.noticeTips4": "Обавештење о Завршетку пуњења упитачке",
  "editUserInfo.errorNotification": "Обавештење о грешки",
  "editUserInfo.updateNotification": "Обавештење о ажурирању",
  "editUserInfo.monthlyStatisticsNotification": "Обавештење о месечним статистикама",
  "editUserInfo.notificationMethod": "Начин примала",

  "editUserInfo.userNameTips1": "Корисничко име је успешно сачувано",
  "editUserInfo.userNameTips2": "Неуспешно сачување корисничког имена",
  "editUserInfo.userNameTips3": "Унесите корисничко име",
  "editUserInfo.userNameTips4": "Неважећи формат корисничког имена: мора садржати бројеве, доње црте и енглеске слова",
  "editUserInfo.userNameTips5": "Унесите корисничко име",
  "editUserInfo.userNameTips6": "Сачување у току... Молимо вас, сачекајте...",
  "editUserInfo.userName": "Корисничко име",

  "editUserInfo.avatorTips": "Кликните да бисте изменили профилну слику",
  "editUserInfo.verifyCodeTips1": "Унесите примљени верификациони код:",
  "editUserInfo.verifyCodeTips2": "За безбедност вашег налога кликните на дугме испод да бисте послали верификациони код на оригинални број телефона:",
  "editUserInfo.verifyCodeTips3": "Пошаљи код",
  "editUserInfo.verifyCodeTips4": "Верификација оригиналног телефона је успешна, унесите нови повезан број телефона",
  "editUserInfo.verifyCodeTips5": "За безбедност вашег налога кликните на дугме испод да бисте послали верификациони код на оригиналну е-пошту:",
  "editUserInfo.verifyCodeTips6": "Верификација оригиналне е-поште је успешна, унесите нову е-пошту",
  "editUserInfo.verifyCodeTips7": "Стара лозинка",
  "editUserInfo.verifyCodeTips8": "Прво повежите е-пошту!",
  "editUserInfo.verifyCodeTips9": "Верификациони код је послат на е-пошту, проверите је",
  "editUserInfo.verifyCodeTips10": ", бићете аутоматски преусмерен на страницу пријава",

  "hems.notice.title": "Наслов обавештења", 
  "hems.notice.content": "Садржај обавештења", 
  "hems.notice.operate": "Рад",
  "hems.notice.noRead": "Непрочитано",
  "hems.notice.read": "Прочитано",
  "hems.notice.warning": "Упозорење",
  "hems.notice.error": "Грешка",
  "hems.notice.success": "Статистичко рачунање",
  "hems.notice.sys": "Системска информација",
  "hems.notice.operateSuccess": "Успешан рад",
  "hems.notice.operateTips": "Изaberite елемент за рад",

  // 首页
  "hems.home.selfuseRate": "Стопа самосталног коришћења",
  "hems.home.percent": "Проценат",
  "hems.home.todayData": "Данасњи подаци",
  "hems.home.todayPowerGeneration": "Данасња производња енергије",
  "hems.home.salesIncome": "Доход од продаје енергије",
  "hems.home.saved": "Уштедили сте",
  "hems.home.reduce": "Смањите угљени отпечатак",
  "hems.home.tips1": "Тренутно нема података, још увек нiste повезали xxxx",
  "hems.home.criticalLoad": "Критично оптерећење",
  "hems.home.keyVoltage": "Критични напон",
  "hems.home.householdLoad": "Оптерећење куће",
  "hems.home.householdVoltage": "Напон куће",
  "hems.home.generalLoad": "Обично оптерећење",
  "hems.home.generalVoltage": "Обични напон",
  "hems.home.batteryHealth": "Здравствен статус батерије",
  "hems.home.averageTemp": "Просечна температура",
  "hems.home.gridLoad": "Оптерећење електричне мреже",
  "hems.home.toggeleDataSource": "Тренутно приказани подаци су промењени у:",
  "hems.home.toggleTips": "Да ли сте сигурни да желите да промените?",
  "hems.home.modeSending": "Пошаљивање наредбе režима у току... Молимо вас, сачекајте...",
  "hems.home.modeSuccess": "Нaredба за промену režима је успешно послата!",
  "hems.home.isOnline": "Да ли је онлајн?",
  "hems.home.useStatus": "Статус коришћења",
  "hems.home.workModeText": "Тренутни режим рада:",
  "hems.home.toggleDataSourceText": "Тренутно приказани подаци су промењени у:",
  "hems.ev.charge.status": "Статус пуњења",
  "hems.ev.charge.time": "Време пуњења",
  "hems.ev.charge.count": "Реални износ пуњења",
  "hems.ev.charge.status.empty": "Празно",
  "hems.ev.charge.status.ing": "Пуњење са повезаним каблем",
  "hems.ev.charge.status.null": "Кабл је повезан, али нема пуњења",
  "hems.ev.charge.status.error": "Грешка",
  "hems.hour": "сат",
  "hems.minue": "минут",
  "hems.ev.chagre.number": "Број упитачке",

  // User Guide
  "hems.userGuide.selfUse": "Самостално коришћење произведене енергије",
  "hems.userGuide.selfUseTips": "Прво користите фотоволтаичну енергију, ако није довољно, попуните из електричне мреже",
  "hems.userGuide.economyMode": "Економички режим",
  "hems.userGuide.economyModeTips": "Оптимизација стратегије коришћења енергије према цени електричне енергије",
  "hems.userGuide.emergencyMode": "Режим хитног случаја",
  "hems.userGuide.emergencyModeTips": "Прво обезбедите напајање критичног оптерећења",

  // 图表页面
  "hems.history.energyStatistics": "Статистика енергије",
  "hems.history.revenueStatistics": "Статистика дохода",
  "hems.history.greenStatistics": "Зелена редукција емисија",
  "hems.history.revenueTitle": "Укупан доход од продаје енергије",
  "hems.history.savingsTitle": "Укупне уштеде",
  "hems.history.carbonTitle": "Укупно смањње угљених емисија",
  "hems.history.day": "дан",
  "hems.history.month": "месец",
  "hems.history.year": "година",
  "hems.history.beforeDay": "Претходни дан",
  "hems.history.afterDay": "Следећи дан",
  "hems.history.beforeMonth": "Претходни месец",
  "hems.history.afterMonth": "Следећи месец",
  "hems.history.beforeYear": "Претходна година",
  "hems.history.afterYear": "Следећа година",
  "hems.history.totalUse": "Укупно коришћење",
  "hems.history.fullScreen": "Цео екран",
  "hems.history.timeSelect": "Избор датума",
  "sync.tips1": "Нaredба за синхронизацију података је успешно послата!",
  "sync.tips2": "Синхронизација података је у току, због великог опсега података потреба је за време, проверите поново после по половине сата~",
  "sync.tips3": "Синхронизација података уређаја може имати закаснање, ако приметите несходство у подацима, кликните на:",
  "sync.tips4": "Синхронизуј податке",

  "charge.info": "Информације о упитачки",
  "news.loading": "Учитавање у току...",
  "news.noMore": "Нема више података",
  "hems.pv.power": "Количина фотоволтаичне енергије",

  // UEH specific
  "ueh.sellPower": "Количина продате енергије",
  
  "menu.home": "Почетна страница",
  "menu.history": "Историјски подаци",
  "menu.device": "Уређаји",
  "menu.settings": "Поставке",
  "menu.messageCenter": "Центар порука",
  "menu.help": "Помоћ и подршка",
  "menu.mine": "Мои подаци",


  "mine.userSetting": "Поставке корисника",
  "mine.terminalSetting": "Основне поставке терминала",
  "mine.uploadCloud": "Отпремање података у облак",
  "mine.changeVersion": "Провера ажурирања",
  "mine.language": "Измена језика",
  "mine.about": "О апликацији",
  "mine.feedback": "Повратна информација",
  "mine.logout": "Одјава",
  "mine.logoutAccount": "Брисање налога",

  "mine.logoutAccountTips": "Брисање налога са именом []",
  "mine.logoutAccountTips1": "Брисање налога повезаног са []",
  "mine.logoutAccountCare": "Напомене о захтеву за брисање налога:",
  "mine.logoutAccountCare1": "1. Налог је у безбедном статусу",
  "mine.logoutAccountCare1-1": "Налог је у нормальному статусу коришћења, нема ризика од крађе, кршења правила или блокирања.",
  "mine.logoutAccountCare2": "2. Ауторизације и везе налога су уклоњене",
  "mine.logoutAccountCare2-1": "Све ауторизације налога са другим трећим странама су уклоњене.",
  "mine.logoutAccountCare3": "3. Након брисања налога га не може се вратити, подаци корисника ће бити обрисани",
  "mine.logoutAccountCare3-1": "Након брисања налога, повезан број телефона, е-пошта и други подаци ће бити обрисани и не могу се вратити.",
  "mine.confirmLogout": "Потврди брисање",
  "mine.logoutSuccess": "Налог је успешно обрисан!",


  "mine.feedbackIssues": "Повратна информација о проблемима",
  "mine.feedQuantity": "Количина",
  "mine.feedAmount": "Максимално 9 слика, максимална величина 1 MB по слици",

  "mine.notice.fail": "Неуспешно узимање поставки обавештења!",
  "mine.notice.saveSuccess": "Поставке обавештења су успешно сачуване!",
  "mine.notice.saveFail": "Неуспешно сачување!",
  "mine.notice.title": "Поставке обавештења",
  "mine.notice.batteryLow": "Обавештење о низком нивоу батерије",
  "mine.notice.chargingFinish": "Обавештење о Завршетку пуњења упитачке",
  "mine.notice.error": "Обавештење о грешки",
  "mine.notice.update": "Обавештење о ажурирању",
  "mine.notice.monthly": "Обавештење о месечним статистикама",
  "mine.notice.receiveType": "Начин примала",

  "mine.language.welcome": "Добродошли у SusprSafe",
  "mine.language.desc1": "Изaberite верзију језика на основу вашег места življenја",
  "mine.language.desc2": "Можете је променити у било ком тренутку у поставкама апликације",

  "mine.userInfo.avatar": "Профилна слика",
  "mine.userInfo.nickname": "Надимак",
  "mine.userInfo.password": "Лозинка",
  "mine.userInfo.changePassword": "Измена лозинке",
  "mine.userInfo.setPassword": "Постављање лозинке",
  "mine.userInfo.phoneNumber": "Број телефона",
  "mine.userInfo.bindPhone": "Веза броја телефона",
  "mine.userInfo.bindEmail": "Веза е-поште",
  "mine.loginExpired": "Статус пријаве је истекао, пријавите се поново",
  "mine.userInfo.title": "Информације о кориснику",
  "mine.userInfo.bind": "Повежи",
  "mine.userInfo.modify": "Уреди",
  "mine.userInfo.modifyNickname": "Измена надимка",
  "mine.userInfo.userNickname": "Надимак корисника",
  "mine.userInfo.selectPic": "Изaberite слику за отпремање",
  "mine.userInfo.saveSuccess": "Успешно сачување",
  "mine.userInfo.uploadFail": "Неуспешно отпремање",
  "mine.userInfo.avatarSaveSuccess": "Профилна слика је успешно сачувана",
  "mine.userInfo.nameTips1": "Надимак корисника не може бити празан",
  "mine.userInfo.nameTips2": "Унесите надимак корисника"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};